import React from "react";
import styled from "styled-components";

import {colors} from "colors";
import Layout from "./Layout";
import { ReactComponent as HTTP404Icon } from "assets/svgs/404.svg";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${colors.charcoalGrey};

  > :nth-child(2) {
    font-size: 36px;
    font-weight: bold;
    margin: 32px 0 0 0;
  }
`;

const HTTP404 = () => {
    return (
        <Layout>
            <Wrapper>
                <HTTP404Icon/>
                <p>Oops!</p>
                <p>Looks like you are on the wrong page..</p>
            </Wrapper>
        </Layout>
    );
};

export default HTTP404;
